import axios from 'axios';
import { getToken, clearToken } from '@/lib/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Add auth token to admin requests
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token && config.url?.includes('/admin')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401s
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname.startsWith('/admin')) {
      clearToken();
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default api;
